import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62ccd2b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 高峰流量应对解决方案 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('节假日出行等流量高峰场景下，通过云资源极速申请，将资源准备周期从数周缩短至小时级，并实现超预期流量的自动扩容，' +
          '支撑业务平稳度过高峰期；随流量下降自动缩容，避免资源浪费，又稳又省应对流量高峰。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$RQ.GoGSS()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费试用 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}